import script from "./bcDataSync.vue?vue&type=script&setup=true&lang=js"
export * from "./bcDataSync.vue?vue&type=script&setup=true&lang=js"

import "./bcDataSync.vue?vue&type=style&index=0&id=01512166&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01512166"]])

export default __exports__